module.exports = __webpack_public_path__ + "static/media/react-native-ui-kits.c5c182e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/react-native-ui-kits.jpg
// module id = 796
// module chunks = 0